
const d3 = require('d3')
const moment = require('moment');
const { TRANSLATE_GENERAL_TAG } = require('../consts');
const { respiratoryIcon } = require('../assets/icons/respiratory-rate')
const { pulseRateIcon } = require('../assets/icons/pulse-rate')

exports.createNightPulseAndRespiratoryChart = (pulseRateData, respiratoryRateData, thresholds, width, height, translate) => {

  const PR_COLOR = '#449B27';
  const RR_COLOR = '#1793C1';
  const MIN_CHART = 0;
  let max_chart = getMaxChart(pulseRateData);

  //get the first item from pulseRateData/respiratoryRateData
  const referenceStart = pulseRateData?.[0]?.date || respiratoryRateData[0]?.date || moment()
  //get the last item from pulseRateData/respiratoryRateData
  const referenceLast = pulseRateData?.[pulseRateData.length-1]?.date || respiratoryRateData?.[respiratoryRateData.length-1]?.date || moment().add(1, 'day')

  //making nice start and end chart in round hours
  const startOfNight = moment.utc(referenceStart).set({minutes: 0})
  const endOfNight = +moment.utc(referenceLast).set({hours: moment.utc(referenceLast).hours()+1, minutes: 0}).toDate()+1

  const margin = { top: 70, right: 70, bottom: 40, left: 50 };
  const x = d3
    .scaleTime()
    .domain(
      [startOfNight, endOfNight]
    )
    .range([margin.left, width - margin.right]);

  const y = d3
    .scaleLinear()
    .domain([MIN_CHART, max_chart])
    .nice()
    .range([height - margin.bottom, margin.top]);

  const xAxis = (g) =>
    g
      .attr('transform', `translate(0,${height - margin.bottom})`)
      .call(
        d3
          .axisBottom(x)
          .ticks(25)
          .tickValues(d3.utcHour
          .every(1)
          .range(startOfNight, endOfNight))
          .tickFormat((d) => {
            return moment.utc(d).format('HH:mm');
          })
          .tickPadding(15)
          .tickSize(0)
      )
      .style('font-size', '15px')
      .style('opacity', 0.5)
      .call((g) =>
        g
          .selectAll('.tick line')
          .clone()
          .attr('stroke-opacity', 0.2)
          .attr('transform', `translate(0,${-height + margin.top + margin.bottom})`)
          .attr('y2', height - margin.top - margin.bottom)
      )
      .call((g) => g.select('.domain').remove());

  const yAxis = (g) =>
    g
      .attr('transform', `translate(${margin.left},0)`)
      .call(
        d3
          .axisLeft(y)
          .tickValues(d3.scaleLinear().domain(y.domain()).ticks())
          .tickFormat(d => d !== 0 ? d : '')
          .tickSize(0)
          .tickPadding(10)
      )
      .style('font-size', '15px')
      .style('opacity', 0.5)
      .call((g) =>
        g
          .selectAll('.tick line')
          .clone()
          .attr('stroke-opacity', 0.2)
          .attr('x2', width - margin.left - margin.right)
      )
      .call((g) => g.select('.domain').remove());

  const pulseRateLineGenerate = d3
    .line()
    .defined((d) => d.value)
    .x((d) => x(moment.utc(d.date)))
    .y((d) => y(d.value));

  const svg = d3.create('svg').attr('width', width).attr('height', height);

  const pulseRateLine = svg
    .append('path')
    .attr('d', pulseRateLineGenerate(pulseRateData))
    .attr('fill', 'none')
    .attr('transform', (d) => `translate(0,0)`)
    .attr('stroke', PR_COLOR);
  
    const respiratoryRateLine = svg
    .append('path')
    .attr('d', pulseRateLineGenerate(respiratoryRateData))
    .attr('fill', 'none')
    .attr('transform', (d) => `translate(0,0)`)
    .attr('stroke', RR_COLOR);

  svg.append('g').call(xAxis);

  svg.append('g').call(yAxis);

  const yAxisPulseRateLabelUnit = svg
    .append('text')
    .attr('x', margin.left - 35)
    .attr('y', margin.top - 25)
    .style('font-size', '15px')

    .attr('fill', '#707070')
    .text(translate ? translate(`${TRANSLATE_GENERAL_TAG}.units.bpm`) : 'bpm');
  
    
    const pulseRateUnitGroup = svg
    .append('g')
    .attr('transform', `translate(${margin.left + 20}, ${margin.top - 25})`)
    
    const pulseRateIconUnit = pulseRateUnitGroup
    .append('g')
    .attr('transform', `translate(0,-13)`);
    pulseRateIconUnit.html(pulseRateIcon)
  
    const pulseRateUnitText = pulseRateUnitGroup
    .append('text')
    .style('font-size', '15px')
    .attr('transform', `translate(25, 0)`)
    .text(translate ? translate(`${TRANSLATE_GENERAL_TAG}.units.pr_night`) : 'Pulse Rate (beats/min)');
  
    const respiratoryRateUnitGroup = svg
    .append('g')
    .attr('transform', `translate(${margin.left + 250}, ${margin.top - 25})`)
    
    const respiratoryRateIconUnit = respiratoryRateUnitGroup
    .append('g')
    .attr('transform', `translate(0,-13)`);
    respiratoryRateIconUnit.html(respiratoryIcon)
  
    const respiratoryRateUnitText = respiratoryRateUnitGroup
    .append('text')
    .style('font-size', '15px')
    .attr('transform', `translate(25, 0)`)
    .text(translate ? translate(`${TRANSLATE_GENERAL_TAG}.units.rr_night`) : 'Respiratory rate (breath/min)');

    const yAxisLabelHrs = svg
    .append('text')
    .attr('x', 0)
    .attr('y', height - 15)
    .style('font-size', '15px')
    .attr('opacity', 0.5)
    .text(translate ? translate(`${TRANSLATE_GENERAL_TAG}.units.hrs`) : 'Hrs');

  
  return svg.node();
};

const getMaxChart = (data) => {
  if(!data) return 60
  const maxVal = Math.max(...data.map(d => d.value))
  return maxVal + 20
}
